import * as _ from "lodash";
import * as React from "react";
import { Country } from "../../earth/model/country";
import { CountryService } from "../../earth/services/countryService";

import { Publication } from "../model/publication";
import { PublicationsService } from "../services/publicationsService";
import { PublicationRankingItem } from "./publicationRankingItem";

const MaxCountriesToDisplay = 5;

interface PublicationRankingProps {
    onPublicationSelected: (publication: Publication) => void;
    visible: boolean;
}

export class PublicationRanking extends React.Component<PublicationRankingProps, {}> {
    constructor(props: PublicationRankingProps) {
        super(props);
    }
    private getPublicationsToDisplay(): Publication[] {
        return PublicationsService.instance.getPublicationsByLikes();
    }
    render(): JSX.Element {
        let publications = this.getPublicationsToDisplay();
        let array: JSX.Element[] = [];
        for ( let row = 0; row < 2; row++ ) {
            array.push(
            <div className="hbox" key={row.toString()}>
            <PublicationRankingItem publication={publications[ 2 * row]} onClick={this.props.onPublicationSelected}/>
            <PublicationRankingItem publication={publications[ 2 * row + 1]} onClick={this.props.onPublicationSelected}/>
            </div>
        );
        }
        return <div className="vbox right-aligned ranking" style={{opacity: this.props.visible ? 1 : 0, transition: "all 0.2s linear"}}>
        <div className="vbox">
        <div className="ranking-title">TOP WORLDWIDE IMAGES</div>
            {array}
        </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/ui/publicationRanking.tsx